import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-purpleDark py-12 text-white" data-id="element-84" data-mp="3gfsmebmgesmg">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-85" data-mp="32o4d0g3lai96">
        <div className="mb-8" data-id="element-86" data-mp="32m1awxp5wyo3">
          <h3 className="mb-2 font-display text-3xl font-bold text-brand-goldLight" data-id="element-87" data-mp="36oy0x9h17x22">🔮 LUMEN AKASHA™</h3>
          <p className="text-white/80" data-id="element-88" data-mp="3uesb1j9yv7im">
            Recursos digitales para estudiar, consultar y aplicar prácticas de bienestar con mayor claridad.
          </p>
        </div>
        <div className="mb-12 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-89" data-mp="3lec768pb9yd8">
          <a className="transition-colors hover:text-brand-goldBright" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-90" data-mp="3qd6u9muba935">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors hover:text-brand-goldBright" href={INSTAGRAM_LINK} data-id="element-91" data-mp="29xvq6ay3z9o9">
            📲 @lumen.akasha
          </a>
          
        </div>
        <div className="space-y-2 text-xs text-white/50" data-id="element-92" data-mp="3l8qvi1vp0fqe">
          <p data-id="element-93" data-mp="3lbdd6ucasbmc">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p data-id="element-94" data-mp="3v9axx7uy7qa7">
            Este material es educativo y de bienestar complementario. No sustituye atención médica, psicológica ni
            terapéutica profesional.
          </p>
        </div>
      </div>
    </footer>;
}